import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ALL_ROUTES } from '../../../../routes/dashboard/overview/AllPathNames';
import { RavenTab } from '@ravenpay/raven-bank-ui';
import { colorToRgba } from '../../../../utils/helper/Helper';

const TabLinksComponent = () => {
	const location = useLocation();
	const navigate = useNavigate();

	const listToUse = [
		{
			label: 'Airtime',
			value: ALL_ROUTES?.BILLS,
			active: location?.pathname === ALL_ROUTES?.BILLS,
			onClick: () => {
				navigate(ALL_ROUTES?.BILLS);
			},
			// component:<AirtimeBill/>
		},
		{
			label: 'Data',
			value: ALL_ROUTES?.BILLS_DATA,
			active: location?.pathname === ALL_ROUTES?.BILLS_DATA,
			onClick: () => {
				navigate(ALL_ROUTES?.BILLS_DATA);
			},
			// component:<DataBill/>
		},
		{
			label: 'Electricity',
			value: ALL_ROUTES?.BILLS_ELECTRICITY,
			active: location?.pathname === ALL_ROUTES?.BILLS_ELECTRICITY,
			onClick: () => {
				navigate(ALL_ROUTES?.BILLS_ELECTRICITY);
			},
			// component:<ElectricityBill/>
		},
		{
			label: 'Cable TV',
			value: ALL_ROUTES?.BILLS_CABLE,
			active: location?.pathname === ALL_ROUTES?.BILLS_CABLE,
			// component:<CabletvBill/>
			onClick: () => {
				navigate(ALL_ROUTES?.BILLS_CABLE);
			},
		},
		{
			label: 'Betting',
			value: ALL_ROUTES?.BILLS_BETTING,
			active: location?.pathname === ALL_ROUTES?.BILLS_BETTING,
			onClick: () => {
				navigate(ALL_ROUTES?.BILLS_BETTING);
			},
		},
	];
	return (
		<>
			{/* reusable tab start */}
			<RavenTab
				activeBgColor={colorToRgba('var(--primary-base-color)', 0.1)}
				activeColor="var(--primary-base-color)"
				list={listToUse}
				style={{ marginTop: '0rem' }}
			/>
			{/* reusable tab end */}
		</>
	);
};

export default TabLinksComponent;
